import { isFunction, set, uniqBy } from "lodash";
import { selectInventory } from "../../../constant/selectors";
import {
    hasError,
    startLoading,
    gotInventory,
    gotShipping,
    gotReceiving,
    gotPos,
    registerItems,
    gotCartForPurchase
} from "./inventory.slice";
import { INVENTORY_FILTER_DEFAULT, } from "../../../constant";
import { referencesCollection, shippingCollection, itemsCollection, receivingCollection, purchaseCollection, cartOrderCollection, TestFunctionCollection } from 'src/constant/firestore'
import { firestore } from "../../../config/firebaseConfig";
import {useEffect} from "react";
import firebase from "firebase/app";
// import { arrayUnion } from "firebase/firestore";
import { batch } from "react-redux";
import {toast} from "react-toastify";



export const getItemInventory = (filters, itemId) => {

    return async (dispatch) => {
        try {
            dispatch(startLoading())

            const query = await itemsCollection.doc(itemId).get();


            let result = [];

            if (query.exists) {
                const doc = { id: query.id, key: query.id, ...query.data() };
                // if (doc?.disable === false) {
                //     switch (type) {
                //         case INVENTORY_TYPE.RUPTURE:
                //             if (doc['outOfStock'][warehouse] === true)
                //                 result = [doc]
                //             break;
                //
                //         case INVENTORY_TYPE.INACTIVE:
                //             if (gDate(doc['SaleDate']) <= gDate(startDate))
                //                 result = [doc]
                //             break;
                //
                //         case INVENTORY_TYPE.WARNING:
                //             if (doc['StockState'][warehouse] === true)
                //                 result = [doc]
                //             break;
                //
                //         default :
                //             result = []
                //     }
                //
                // }


                // const hasToBuyFilter = doc.hasToBuy


                // if (doc?.hasToBuy === true) {

                //     hasToBuyFilters = [doc?.hasToBuy]

                // }
                // result = [hasToBuyFilters]
                result = [doc]

            }

            dispatch(gotInventory({
                list: result,
                cursor: null,
                hasMore: false
            }))

        } catch (error) {
            dispatch(hasError(error))
        }
    }
}
/*
export const DisableProductInventory = (ids = [], callback = null) => {
    return async (dispatch) => {
        try {
            const batch = firestore.batch();

            ids.forEach(id => {
                const ref = itemsCollection.doc(id)
                batch.update(ref, { disable: true })
            })

            await batch.commit()

            isFunction(callback) && callback()

        } catch (error) {
            dispatch(hasError(error))
        }
    }
}*/

export const getInventory = (filters, loadMore = false, limit = 100, callback = null, filterbyDate ="") => {

    return async (dispatch, getState) => {
        try {

            dispatch(startLoading())


            const { cursor, list } = selectInventory(getState());
            let queryRef = null;
            let startDate = null
            let endDate = null
            let docSnap = null
            let items = null
            let VendorId = null
            var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'))
            

            if (ComposeFilter === null){
                queryRef = itemsCollection
                    //.where('QuantityAvailable', '>=', 0)
                    //.where('hasToBuy', '==', true)
                    .where('disable', '==', false)
                    //.orderBy('QuantityAvailable', 'asc')
                    .limit(limit);
try {
    const docSnap = await queryRef.get()
    items = docSnap.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() })).filter(e => e.disable !== true && e.ReceptionDate !== null && (e.Vendors[VendorId].InCart ? e.Vendors[VendorId].InCart == 'no' : e.Vendors[VendorId].InCart == 'no')  )
    console.log(items, 'nos items');


}catch (e) {
    console.error(e)
}
           }else{
            const VendorId =  ComposeFilter?.delivery?.vendor.id
            console.log(VendorId);

                if(ComposeFilter?.lastDate !== null){
                    
                    startDate = new Date(ComposeFilter?.lastDate)

                    const firstQueryRef = itemsCollection
                        .where('VendorIds', 'array-contains', ComposeFilter?.delivery?.vendor.id)
                        //.where('hasToBuy', '==', true)
                        .where('disable', '==', false)
                        .where('ReceptionDate', '<', startDate)
                        .limit(limit)
                    const secondQueryRef = itemsCollection
                        //.where('QuantityAvailable', '>=', 0)
                        .where('VendorIds', 'array-contains', ComposeFilter?.delivery?.vendor.id)
                        //.where('hasToBuy', '==', true)
                        .where('disable', '==', false)
                        .where('ReceptionDate', '==', null)
                        .limit(limit);

                    queryRef = [firstQueryRef,secondQueryRef]


                    try {
                        const snapshots = await Promise.all(queryRef.map((ref) => ref.get()));

                        items = snapshots.flatMap((snapshot) => snapshot.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() })).filter(e => e.disable !== true && (e.Vendors[VendorId].InCart == null || e.Vendors[VendorId].InCart == 'no') ));
                        console.log(items, 'nos items');

                    } catch (error){
                        console.error(error)
                    }

                }else
                if(filterbyDate !== ""){

                    queryRef = itemsCollection
                        //.where('QuantityA vailable', '>=', 0)
                        .where('DateOfRupture', '==', filterbyDate)
                        //.where('hasToBuy', '==', true)
                     
                        .where('disable', '==', false)
                        .orderBy('QuantityAvailable', 'asc')
                        .limit(limit);
                    const docSnap = await queryRef.get()
                    console.log(queryRef)


                    items = docSnap.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() })).filter(e => { 
                        return (e.disable !== true && e.ReceptionDate !== null && (e.Vendors[VendorId].InCart == null || e.Vendors[VendorId].InCart == 'no') )
                    }   )
                    console.log(items, 'nos items');


                }
                else if(ComposeFilter?.date?.start !== null && ComposeFilter?.date?.end !== null && ComposeFilter?.delivery?.vendor !== null ){
                    startDate = new Date(ComposeFilter?.date?.start)
                    endDate = new Date(ComposeFilter?.date?.end)
                    console.log('hiii')
                    const commonQuery = itemsCollection
                        .where('VendorIds', 'array-contains', ComposeFilter?.delivery?.vendor.id)
                        .where('DateOfRupture', '>=', startDate)
                        .where('DateOfRupture', '<=', endDate)
                        //.where('hasToBuy', '==', true)
                        .where('disable', '==', false);


                    const firstQueryRef = commonQuery
                        .orderBy('DateOfRupture', 'asc')
                        .limit(limit);

                    const secondQueryRef = commonQuery
                        .where('ReceptionDate', '!=', null)
                        .orderBy('DateOfRupture', 'asc')
                        .limit(limit);

                    queryRef = [firstQueryRef,secondQueryRef]

                    try {
                        const snapshots = await Promise.all(queryRef.map((ref) => ref.get()));

                        items = snapshots.flatMap((snapshot) => snapshot.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() }))
                        .filter(e => {console.log(2,e,e.Vendors[VendorId].InCart ) 
                            return (e.disable !== true && e.ReceptionDate !== null && (e.Vendors[VendorId].InCart == null || e.Vendors[VendorId].InCart == 'no') )
                        }   ))
                        ;

                        console.log(items, 'nos items');

                    } catch (error){
                        console.error(error)
                    }

                }
                else if(ComposeFilter?.date?.start !== null && ComposeFilter?.date?.end !== null && ComposeFilter?.delivery?.vendor === null){
                    startDate = new Date(ComposeFilter?.date?.start)
                    endDate = new Date(ComposeFilter?.date?.end)
                    queryRef = itemsCollection
                        .where('DateOfRupture', '>=', startDate)
                        .where('DateOfRupture', '<=', endDate)
                        //.where('QuantityAvailable', '>=', 0)
                        .where('disable', '==', false)
                        .orderBy('DateOfRupture', 'asc')
                        .limit(limit);

                    try {
                        const docSnap = await queryRef.get()
                        console.log(queryRef)

                        items = docSnap.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() }))
                        .filter(e => {console.log(3,e,e.Vendors[VendorId].InCart ) 
                            return (e.disable !== true && e.ReceptionDate !== null && (e.Vendors[VendorId].InCart == null || e.Vendors[VendorId].InCart == 'no') )
                        }   )
                        console.log(items, 'nos items');


                    }catch (e) {
                        console.error(e)
                    }

                }
                else if(ComposeFilter?.delivery?.vendor !== null && (ComposeFilter?.date?.start === null || ComposeFilter?.date?.end === null)){
                    console.log("object");

                    queryRef = itemsCollection
                        //.where('QuantityAvailable', '>=', 0)
                        .where('VendorIds', 'array-contains', ComposeFilter?.delivery?.vendor.id)
                        .where('disable', '==', false)
                        .orderBy('QuantityAvailable', 'asc')
                        .limit(limit);
                        try {
                            const docSnap = await queryRef.get();
                           
                            items = docSnap.docs
                              .map((doc) => ({ id: doc.id, key: doc.id, ...doc.data() }))
                              .filter((e) => {
                          
                                // Check for null values before accessing properties
                                const receptionDateNotNull = e.ReceptionDate !== null;
                                const inCartNotNull = e.Vendors && e.Vendors[VendorId];
                          
                        
                          
                                const meetsCondition = receptionDateNotNull && inCartNotNull && (e.Vendors[VendorId].InCart == null || e.Vendors[VendorId].InCart == 'no')  ;
                          
                                return meetsCondition;
                              });
                          
                            console.log('Filtered Items:', items);
                            console.log(items.length, 'items after filter');
                          } catch (e) {
                            console.error('error', e);
                          }
                  }
                else{
                    //console.log("object");
                    queryRef = itemsCollection
                        //.where('QuantityAvailable', '>=', 0)
                        .where('disable', '==', false)
                        //.orderBy('QuantityAvailable', 'asc')
                        .orderBy('IsInCart', 'asc')
                        .limit(limit);
                    try {
                        const docSnap = await queryRef.get()

                        items = docSnap.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() }))
                        .filter(e => {console.log(5,e,e.Vendors[VendorId].InCart ) 
                            return (e.disable !== true && e.ReceptionDate !== null && (e.Vendors[VendorId].InCart == null || e.Vendors[VendorId].InCart == 'no') )
                        }   )
                        console.log(items, 'nos items');


                    }catch (e) {
                        console.error(e)
                    }
                }
            }




           /* docSnap = loadMore
                ? await queryRef.startAfter(cursor).get()
                : await queryRef.get();*/
/*
            const items = docSnap.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() })).filter(e => e.disable !== true);
*/

console.log(items, 'itemsss');

            dispatch(gotInventory({
            
                list: loadMore ? [...list, ...items] : items,
                cursor: 10,
                hasMore: !(items.length < limit)
            }))
            isFunction(callback) && callback()
        } catch (error) {
            dispatch(hasError(error))
        }
    }
}


export const getCurrentINShippingOrders = (callback = false) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading())

            const inShippingSnap = await shippingCollection
                .where('ActivityStatus', '==', 'InShipping').get()

            const shippedSnap = await shippingCollection
                .where('ActivityStatus', '==', 'Shipped').get()

            let list = []

            const formatResult = async (doc) => {

                const result = doc.data()?.Shippings || []
                list = [...list, ...result.map(one => ({
                    ...one,
                    ShippingID: doc.id,
                    ContainerCode: doc.data()?.ContainerCode,
                    ActivityStatus: doc.data()?.ActivityStatus
                }))];

                const subCollections = await shippingCollection.doc(doc.id).collection('Shippings_c').get();
                list = [...list, ...subCollections.docs.map(one => ({
                    id: one.id,
                    ...one.data(),
                    ShippingID: doc.id,
                    ContainerCode: doc.data()?.ContainerCode,
                    ActivityStatus: doc.data()?.ActivityStatus
                }))]

            }

            await Promise.all(inShippingSnap.docs.map(formatResult))

            await Promise.all(shippedSnap.docs.map(formatResult))

            const result = list.map(item => ({
                ...item,
                id: item?.ProductId,
                shipping: list.filter(record => record?.ProductId === item?.ProductId).map(record => ({
                    id: record?.ShippingID,
                    ref: record?.ContainerCode,
                    state: record?.ActivityStatus,
                    quantity: record?.Quantity
                })),
                totalQuantity: list?.filter(record => record?.ProductId === item?.ProductId)
                    ?.map(record => Number(record?.Quantity || 0))
                    ?.reduce((a, b) => a + b)
            })).map(({ ShippingID, ContainerCode, ActivityStatus, ...rest }) => ({ ...rest }))

            dispatch(gotShipping(uniqBy(result, 'ProductId')))

            isFunction(callback) && callback()
        } catch (error) {
            dispatch(hasError(error))
        }
    }
}

export const getActivePurchaseOrders = (callback = false) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading())

            const queryResult = await purchaseCollection
                .where('ActivityStatus', '!=', 'Shipped')
                // .where('ActivityStatus', '!=', 'Shipped')
                .get()

            let list = []

            queryResult.docs.forEach(doc => {
                const data = (doc.data()?.Purchases || [])
                    ?.map(one => ({
                        ...one,
                        poId: doc.id,
                        ref: doc.data()?.PoRef || '',
                        state: doc.data()?.ActivityStatus || ''
                    }))
                list = [...list, ...data]
            })

            const result = list?.map(one => ({
                ...one,
                id: one?.ItemId,
                pos: list?.filter(record => record?.ItemId === one?.ItemId)?.map(record => {
                    const toString = String(record?.ref);
                    const numberOfZero = 8 - toString.length;
                    return ({
                        id: record?.poId,
                        ref: `Po-${'0'.repeat(numberOfZero)}${toString}`,
                        state: record?.state,
                        quantity: record?.Quantity
                    })
                }),
                totalQuantity: list?.filter(record => record?.ItemId === one?.ItemId)
                    ?.map(record => Number(record?.Quantity || 0))
                    ?.reduce((a, b) => a + b)
            }))?.map(({ poId, ref, state, ...rest }) => ({ ...rest }))

            dispatch(gotPos(uniqBy(result, 'ItemId')))

            isFunction(callback) && callback()
        } catch (error) {
            dispatch(hasError(error))
        }
    }
}

export const getCurrentINReceivingOrders = (callback = false) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading())

            const queryResult = await receivingCollection
                .where('ActivityStatus', '==', 'Open')
                .where('isOpen', '==', true)
                .get()

            let list = []

            queryResult.docs.forEach(doc => {
                const data = doc.data()?.ReceivedItems || [];
                list = [...list, ...data]
            })

            dispatch(gotReceiving(list))

            isFunction(callback) && callback()
        } catch (error) {
            dispatch(hasError(error))
        }
    }
}

export const disableItem = (ids = [], callback = null) => { 
    return async (dispatch) => {
        try {
            const batch = firestore.batch();

            ids.forEach(id => {
                const ref = itemsCollection.doc(id)
                batch.update(ref, { disable: true })
            })

            await batch.commit()

            isFunction(callback) && callback()

        } catch (error) {
            dispatch(hasError(error))
        }
    }
}

export const AddToCartForOder = (SelectedItem = [], userInfo = null, callback = null) => {
    if(Object.prototype.toString.call(SelectedItem) === "[object Object]"){
        SelectedItem = SelectedItem?.Items
    }


    return async (dispatch) => {
        console.log(SelectedItem, 'item debug')

        try {
            const batch = firestore.batch();
              var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'))
    //         let lastCartRef

    //         console.log(ComposeFilter, ' local storage debug')
           // SelectedItem.forEach(item => 
           const idVendor = ComposeFilter.delivery.vendor.id;
                   const vendorName = ComposeFilter.delivery.vendor.name; // Remplacez par la valeur de votre variable idVendor
           for (const item of SelectedItem)
                {
                   const ref = itemsCollection.doc(item.id)
                   const idVendor = ComposeFilter.delivery.vendor.id;
                   const vendorName = ComposeFilter.delivery.vendor.name; // Remplacez par la valeur de votre variable idVendor
                   let username = firebase.auth()?.currentUser?.displayName;
                   let newQToBuy = Number(item.QuantityInPO)+Number(item.QuantityInShpping)+Number(item.QuantityToBuy);
    //                //alert("idvendore: "+idVendor+ " vendorName: "+vendorName+ " Username: " +userInfo.displayName+ "q saisie: "+item.QuantityToBuy + "Q a acheter: "+newQToBuy+ "Reste a acheter: "+item.RestQtyToBuy);
                   const updatevendorData = {
                    [`Vendors.${idVendor}.InCart`]: 'yes',
                 };

                  const updateOrderInfoData = [
                    {
                        qNew: item.QuantityToBuy,
                        qOld: item.RestQtyToBuy,
                        todo:"add to cart",
                        updateAt: new Date(),
                        user:username,
                        vendors:vendorName
                    }
                  ];
    // //              //Changement de l'etat pour dire que le produit est mise dans le panier du vendor tel
                     batch.update(ref,updatevendorData);
    //               //Mise a jour de la quantité à acheter [PO + SHIP + Nouvelle quantité]
                     batch.update(ref, {'RestQtyToBuy' : item.QuantityToBuy});
                     batch.update(ref, {'QuantityToBuy': newQToBuy});
                    
                     ref.set({OrderInfo: firebase.firestore.FieldValue.arrayUnion(...updateOrderInfoData),},
                     {merge: true},)
              // alert('salutation produit: '+ item.id+ " id vendor: "+ idVendor+ " Q saisie: "+item.QuantityToBuy+ " Username: " +userInfo.displayName+ " PO: "+ item.QuantityInPO + " Ship: "+item.QuantityInShpping+ " Qtobuy: "+newQToBuy);

            }
            batch.commit();
            toast.success('Ajout au panier de '+ vendorName+' avec succès');
    //         await batch.commit()
          //isFunction(callback) && callback()
        } catch (error) {
           // dispatch(hasError(error))
            toast.error('Une erreur .');

        }
   }
}

export const AddToValidationCartForOder = (SelectedItem = [], userInfo = null, callback = null) => {
    if(Object.prototype.toString.call(SelectedItem) === "[object Object]"){
        SelectedItem = SelectedItem?.Items
    }


    return async (dispatch) => {
        console.log(SelectedItem, 'item debug')

        try {
            const batch = firestore.batch();
              var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'))
    //         let lastCartRef

    //         console.log(ComposeFilter, ' local storage debug')
           // SelectedItem.forEach(item => 
           const idVendor = ComposeFilter.delivery.vendor.id;
                   const vendorName = ComposeFilter.delivery.vendor.name; // Remplacez par la valeur de votre variable idVendor
           for (const item of SelectedItem)
                {
                   const ref = itemsCollection.doc(item.id)
                   const idVendor = ComposeFilter.delivery.vendor.id;
                   const vendorName = ComposeFilter.delivery.vendor.name; // Remplacez par la valeur de votre variable idVendor
                   let username = firebase.auth()?.currentUser?.displayName;
                   let newQToBuy = Number(item.QuantityInPO)+Number(item.QuantityInShpping)+Number(item.QuantityToBuy);
    //                //alert("idvendore: "+idVendor+ " vendorName: "+vendorName+ " Username: " +userInfo.displayName+ "q saisie: "+item.QuantityToBuy + "Q a acheter: "+newQToBuy+ "Reste a acheter: "+item.RestQtyToBuy);
                   const updatevendorData = {
                    [`Vendors.${idVendor}.InCart`]: 'attente',
                 };

                  const updateOrderInfoData = [
                    {
                        qNew: item.QuantityToBuy,
                        qOld: item.RestQtyToBuy,
                        todo:"for validation",
                        updateAt: new Date(),
                        user:username,
                        vendors:vendorName
                    }
                  ];
    // //              //Changement de l'etat pour dire que le produit est mise dans le panier du vendor tel
                     batch.update(ref,updatevendorData);
    //               //Mise a jour de la quantité à acheter [PO + SHIP + Nouvelle quantité]
                     batch.update(ref, {'RestQtyToBuy' : item.QuantityToBuy});
                     batch.update(ref, {'QuantityToBuy': newQToBuy});
                    
                     ref.set({OrderInfo: firebase.firestore.FieldValue.arrayUnion(...updateOrderInfoData),},
                     {merge: true},)
              // alert('salutation produit: '+ item.id+ " id vendor: "+ idVendor+ " Q saisie: "+item.QuantityToBuy+ " Username: " +userInfo.displayName+ " PO: "+ item.QuantityInPO + " Ship: "+item.QuantityInShpping+ " Qtobuy: "+newQToBuy);

            }
            batch.commit();
            toast.success('Ajout au panier de validation de '+ vendorName+' avec succès');
    //         await batch.commit()
          //isFunction(callback) && callback()
        } catch (error) {
           // dispatch(hasError(error))
            toast.error('Une erreur .');

        }
   }
}

export const UpdateBadgeForOder = (SelectedItem = [], userInfo = null,badge, callback = null) => {
    if(Object.prototype.toString.call(SelectedItem) === "[object Object]"){
        SelectedItem = SelectedItem?.Items
    }


    return async (dispatch) => {
        console.log(SelectedItem, 'item debug')

        try {
            const batch = firestore.batch();
              var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'))
    //         let lastCartRef

    //         console.log(ComposeFilter, ' local storage debug')
           // SelectedItem.forEach(item => 
           const idVendor = ComposeFilter.delivery.vendor.id;
                   const vendorName = ComposeFilter.delivery.vendor.name; // Remplacez par la valeur de votre variable idVendor
           for (const item of SelectedItem)
                {
                   const ref = itemsCollection.doc(item.id)
                   const idVendor = ComposeFilter.delivery.vendor.id;
                   const vendorName = ComposeFilter.delivery.vendor.name; // Remplacez par la valeur de votre variable idVendor
                   //let username = firebase.auth()?.currentUser?.displayName;
                   //let newQToBuy = Number(item.QuantityInPO)+Number(item.QuantityInShpping)+Number(item.QuantityToBuy);
    //                //alert("idvendore: "+idVendor+ " vendorName: "+vendorName+ " Username: " +userInfo.displayName+ "q saisie: "+item.QuantityToBuy + "Q a acheter: "+newQToBuy+ "Reste a acheter: "+item.RestQtyToBuy);
                //    const updatevendorData = {
                //     [`Vendors.${idVendor}.InCart`]: 'attente',
                //  };

                //   const updateOrderInfoData = [
                //     {
                //         qNew: item.QuantityToBuy,
                //         qOld: item.RestQtyToBuy,
                //         todo:"for validation",
                //         updateAt: new Date(),
                //         user:username,
                //         vendors:vendorName
                //     }
                //   ];
    // //              //Changement de l'etat pour dire que le produit est mise dans le panier du vendor tel
                     //batch.update(ref,updatevendorData);
    //               //Mise a jour de la quantité à acheter [PO + SHIP + Nouvelle quantité]
                     //batch.update(ref, {'RestQtyToBuy' : item.QuantityToBuy});
                     batch.update(ref, {'Badge': badge});
                    
            //          ref.set({OrderInfo: firebase.firestore.FieldValue.arrayUnion(...updateOrderInfoData),},
            //          {merge: true},)
            //    alert('salutation produit: '+ item.id+ " id vendor: "+ idVendor+ " Q saisie: "+item.QuantityToBuy+ " Username: " +userInfo.displayName+ " PO: "+ item.QuantityInPO + " Ship: "+item.QuantityInShpping+ " Qtobuy: "+newQToBuy);

            }
            batch.commit();
            toast.success('Urgence de '+ vendorName+' avec succès');
    //         await batch.commit()
          //isFunction(callback) && callback()
        } catch (error) {
           // dispatch(hasError(error))
            toast.error('Une erreur .');

        }
   }
}

export const AddToValidationCart=({itemid,newQToBuy,newQuantity,OldQuantity,username,Restant})=>{
    //return async (dispatch) =>{
        try{
            const batch = firestore.batch();
            console.log(itemid);
            var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'));
            const ref = itemsCollection.doc(itemid);
            const idVendor = ComposeFilter.delivery.vendor.id;
            const vendorName = ComposeFilter.delivery.vendor.name;
            const updatevendorData = {
                [`Vendors.${idVendor}.InCart`]: 'attente',
            };
                        // alert(vendorName);
            // const updatevendorData = [`Vendors.${idVendor}.InCart`]+":yes";
            //         alert(updatevendorData);
            const updateOrderInfoData = [
                {
                    qNew: newQuantity,
                    qOld: Restant,
                    todo:"for validation",
                    updateAt: new Date(),
                    user:username,
                    vendors:vendorName
                }
            ];
            //Changement de l'etat pour dire que le produit est mise dans le panier du vendor tel
            batch.update(ref,updatevendorData);
            //Mise a jour de la quantité à acheter [PO + SHIP + Nouvelle quantité]
            batch.update(ref, {'RestQtyToBuy' : newQuantity});
            batch.update(ref, {'QuantityToBuy': newQToBuy});
            batch.commit();
            ref.set({OrderInfo: firebase.firestore.FieldValue.arrayUnion(...updateOrderInfoData),},
            {merge: true},)
            // alert(" vendorName: "+vendorName);
            //document.getElementById("card"+itemid).style.display="none";
            toast.success('Ajout au panier de validation '+ vendorName+' avec succès');
        }
        catch(error){
            //dispatch(hasError(error))
            toast.error('Une erreur s\'est produite lors de l\'ajout du produit au panier de validation.');
        }
   // }
    //alert(itemid+" saisie: "+newQuantity+ " Tobuy: "+newQToBuy+"Reste a acheter : "+Restant);
}



export const AddToCart=({itemid,newQToBuy,newQuantity,OldQuantity,username,Restant})=>{

        try{

            console.log('try');
            const batch = firestore.batch();
          
            var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'));
            const ref = itemsCollection.doc(itemid);
            const idVendor = ComposeFilter.delivery.vendor.id;
            const vendorName = ComposeFilter.delivery.vendor.name;
            const updatevendorData = {
                [`Vendors.${idVendor}.InCart`]: 'yes',
            };
                        // alert(vendorName);
            // const updatevendorData = [`Vendors.${idVendor}.InCart`]+":yes";
            //         alert(updatevendorData);
            const updateOrderInfoData = [
                {
                    qNew: newQuantity,
                    qOld: Restant,
                    todo:"add to cart",
                    updateAt: new Date(),
                    user:username,
                    vendors:vendorName
                }
            ];
            //Changement de l'etat pour dire que le produit est mise dans le panier du vendor tel
            batch.update(ref,updatevendorData);
            //Mise a jour de la quantité à acheter [PO + SHIP + Nouvelle quantité]
            batch.update(ref, {'RestQtyToBuy' : newQuantity});
            batch.update(ref, {'QuantityToBuy': newQToBuy});
             batch.commit();

            ref.set({OrderInfo: firebase.firestore.FieldValue.arrayUnion(...updateOrderInfoData),},
            {merge: true},)
            //document.getElementById("card"+itemid).style.display="none";

            // alert(" vendorName: "+vendorName);
            toast.success('Ajout au panier de '+ vendorName+' avec succès');

        }
        catch(error){

            console.log(error);
            // dispatch(hasError(error))

            toast.error('Une erreur s\'est produite lors de l\'ajout du produit au panier.');
        }
    // }
    //alert(itemid+" saisie: "+newQuantity+ " Tobuy: "+newQToBuy+"Reste a acheter : "+Restant);
}

export const UpdateQty=({itemid,newQToBuy,newQuantity,OldQuantity,username,Restant,vendorid,vn})=>{

    try{

        console.log('try');
        const batch = firestore.batch();
      
        //var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'));
        const ref = itemsCollection.doc(itemid);
        // const idVendor = ComposeFilter.delivery.vendor.id;
        // const vendorName = ComposeFilter.delivery.vendor.name;
        const updatevendorData = {
            [`Vendors.${vendorid}.InCart`]: 'yes',
        };
                    // alert(vendorName);
        // const updatevendorData = [`Vendors.${idVendor}.InCart`]+":yes";
        //         alert(updatevendorData);
        const updateOrderInfoData = [
            {
                qNew: newQuantity,
                qOld: Restant,
                todo:"update quantity",
                updateAt: new Date(),
                user:username,
                vendors:vn
            }
        ];
        //Changement de l'etat pour dire que le produit est mise dans le panier du vendor tel
        batch.update(ref,updatevendorData);
        //Mise a jour de la quantité à acheter [PO + SHIP + Nouvelle quantité]
        batch.update(ref, {'RestQtyToBuy' : newQuantity});
        batch.update(ref, {'QuantityToBuy': newQToBuy});
         batch.commit();

        ref.set({OrderInfo: firebase.firestore.FieldValue.arrayUnion(...updateOrderInfoData),},
        {merge: true},)
        //document.getElementById("card"+itemid).style.display="none";

        // alert(" vendorName: "+vendorName);
        toast.success('Ajout au panier de '+ vn+' avec succès');

    }
    catch(error){

        console.log(error);
        // dispatch(hasError(error))

        toast.error('Une erreur s\'est produite lors de l\'ajout du produit au panier.');
    }
// }
//alert(itemid+" saisie: "+newQuantity+ " Tobuy: "+newQToBuy+"Reste a acheter : "+Restant);
}

export const Saveforlater=({itemid,newQuantity,OldQuantity,username,Restant,VendorId,vn})=>{
    //return async (dispatch) =>{
        try{
            const batch = firestore.batch();
            console.log(itemid);
            var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'));
            const ref = itemsCollection.doc(itemid);
            // const idVendor = ComposeFilter.delivery.vendor.id;
            // const vendorName = ComposeFilter.delivery.vendor.name;
            const updatevendorData = {
                [`Vendors.${VendorId}.InCart`]: 'later',
            };
                        // alert(vendorName);
            // const updatevendorData = [`Vendors.${idVendor}.InCart`]+":yes";
            //         alert(updatevendorData);
            const updateOrderInfoData = [
                {
                    qNew: Restant,
                    qOld: Restant,
                    todo:"Save for Later",
                    updateAt: new Date(),
                    user:username,
                    vendors:vn
                }
            ];
            //Changement de l'etat pour dire que le produit est mise dans le panier du vendor tel
            batch.update(ref,updatevendorData);
            //Mise a jour de la quantité à acheter [PO + SHIP + Nouvelle quantité] et du reste à acheter qui est {newquantity - saisie ou  RestToBuy}
            batch.update(ref, {'RestQtyToBuy' : Restant});
            batch.update(ref, {'QuantityToBuy': newQuantity});
            batch.commit();
            ref.set({OrderInfo: firebase.firestore.FieldValue.arrayUnion(...updateOrderInfoData),},
            {merge: true},)
            // alert(" vendorName: "+vendorName);
            document.getElementById("card"+itemid).style.display="none";
            toast.success('Save for later avec succès');

        }
        // catch(e){
        //     console.log(e);
        // }
        catch(error){

            console.log(error);
            // dispatch(hasError(error))

            toast.error('Une erreur s\'est produite lors du save dor later.');
        }
    }

export const Removefromcart=({itemid,newQuantity,OldQuantity,username,Restant,vendorid,vn})=>{
    //return async (dispatch) =>{
        try{
            const batch = firestore.batch();
            console.log(itemid);
            //var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'));
            const ref = itemsCollection.doc(itemid);
            // const idVendor = ComposeFilter.delivery.vendor.id;
            // const vendorName = ComposeFilter.delivery.vendor.name;
            const updatevendorData = {
                [`Vendors.${vendorid}.InCart`]: 'no',
            };
                        // alert(vendorName);
            // const updatevendorData = [`Vendors.${idVendor}.InCart`]+":yes";
            //         alert(updatevendorData);
            const updateOrderInfoData = [
                {
                    qNew: Restant,
                    qOld: Restant,
                    todo:"remove from cart",
                    updateAt: new Date(),
                    user:username,
                    vendors:vn
                }
            ];
            //Changement de l'etat pour dire que le produit est mise dans le panier du vendor tel
            batch.update(ref,updatevendorData);
            //Mise a jour de la quantité à acheter [PO + SHIP + Nouvelle quantité] et du reste à acheter qui est {newquantity - saisie ou  RestToBuy}
            batch.update(ref, {'RestQtyToBuy' : Restant});
            batch.update(ref, {'QuantityToBuy': newQuantity});
            batch.commit();
            ref.set({OrderInfo: firebase.firestore.FieldValue.arrayUnion(...updateOrderInfoData),},
            {merge: true},)
            // alert(" vendorName: "+vendorName);
            document.getElementById("card"+itemid).style.display="none";
            toast.success('Suppression du panier de '+ vn+' avec succès');

        }
        catch(error){

            console.log(error);
            // dispatch(hasError(error))

            toast.error('Une erreur s\'est produite lors du remove du produit du panier.');
        }
    }

export const updateBadge = ({itemid,niveau}) =>{
    try{
        const batch = firestore.batch();
        console.log(itemid);
        var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'));
        const ref = itemsCollection.doc(itemid);
        //Changement de l'etat du niveau du produit en urgent ou moins urgent ou normal
        batch.update(ref, {'Badge': niveau});
        batch.commit();
        toast.success('Urgence choisi lier au produit avec succes!');

    }
    catch(error){
        //dispatch(hasError(error))
        toast.error('ERROR.');
    }
}
// export const AddToCartForOder = (SelectedItem = [], userInfo = null, callback = null) => {
//     if(Object.prototype.toString.call(SelectedItem) === "[object Object]"){
//         SelectedItem = SelectedItem?.Items
//     }


//     return async (dispatch) => {
//         try {

//             //console.log("Before ComposeFilter 11");
//             var ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'))

//             let docCardRef = await referencesCollection.doc("card_ref").get()
//             let lastCartRef

//             if(docCardRef.exists){
//                 lastCartRef = docCardRef.data().data
//             }

//             await referencesCollection.doc("card_ref").update({
//                 "data": lastCartRef+1
//             })




//             if (ComposeFilter.delivery.vendor !== null) {

//                 const VendorId = ComposeFilter?.delivery?.vendor.id
//                 const VendorName = ComposeFilter?.delivery?.vendor.name
//                 let docSnap = await cartOrderCollection
//                     .where('VendorsId', '==', VendorId)
//                     .where('IsInOder', '==', false)
//                     .where('IsValidCart', '==', false)
//                     .get()


//                 const batch = firestore.batch();

//                 if (!docSnap.empty) {
//                     // let a = docSnap.docs.data()

//                     const my_cart = docSnap.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() }))
//                     let cartSnap = await cartOrderCollection.doc(my_cart[0].id).collection("cart_items").get()

//                     let cartItem = cartSnap.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() }))
//                     if (cartItem.length >= 100) {
//                         // si les item dans le panier est == 100, on met isInOrder a true
//                         let refCurrentCart = cartOrderCollection.doc(my_cart[0].id)
//                         batch.update(refCurrentCart,{IsInOder: true})
//                         // et On cree un new Panier
//                         //console.log("On cree un new Panier car cartItem.length >= 100");

//                         const refCart = cartOrderCollection.doc()

//                         for (const data of SelectedItem) {
//                             data.InCart = true;
//                             batch.set(refCart, { CartRef: lastCartRef+1,  CreatedBy: userInfo, IsValidCart: false, IsInOder: false, CreateAt: new Date(), VendorsId: VendorId, VendorName: VendorName })

//                             const refItem = itemsCollection.doc(data.id)
//                             batch.update(refItem, { IsInCart: true })

//                             const doc = await cartOrderCollection.doc(refCart.id).collection("cart_items").doc(data.id).set(
//                                 {
//                                     Categorie: data.Categorie,
//                                     ItemId: data.id,
//                                     ImageUrl: data.ImageUrl,
//                                     InternalId: data.InternalId,
//                                     LastBuyPrice: data?.LastBuyPrice ?? 0,
//                                     QuantityInPO: data.QuantityInPO,
//                                     QuantityInShpping: data.QuantityInShpping,
//                                     SalePriceMutator: data.SalePriceMutator,
//                                     VendorIds: data.VendorIds,
//                                     hasToBuy: data.hasToBuy,
//                                     Vendors: data?.Vendors  ?? null,
//                                     QuantityToBuy: data?.QuantityToBuy,
//                                     RestQtyToBuy: data?.QuantityToBuy,
//                                     Name: data.Name,
//                                     UPC: data.UPC,
//                                 });
//                         }

//                     }else{
//                          // on ajoute de nouveaux produits dans l'ancien panier

//                         const refCart = cartOrderCollection.doc()
//                         for (const data of SelectedItem) {
//                             data.InCart = true;
//                             // si IsInOder == true, on est oblige de creer un new cart
//                             // si on supprime un produit dans la cart, on le remet hastobuy = true et IsInCart = false
//                             // si IsValidCart == true, on affiche ces produits sur l'application mobile

//                             const refItem = itemsCollection.doc(data.id)
//                             batch.update(refItem, { IsInCart: true })

//                             const doc = await cartOrderCollection.doc(my_cart[0].id).collection("cart_items").doc(data.id).set(
//                                 {
//                                     Categorie: data.Categorie,
//                                     ItemId: data.id,
//                                     ImageUrl: data.ImageUrl,
//                                     InternalId: data.InternalId,
//                                     LastBuyPrice: data?.LastBuyPrice ?? 0,
//                                     QuantityInPO: data.QuantityInPO,
//                                     QuantityInShpping: data.QuantityInShpping,
//                                     SalePriceMutator: data.SalePriceMutator,
//                                     hasToBuy: data.hasToBuy,
//                                     Vendors: data?.Vendors  ?? null,
//                                     QuantityToBuy: data?.QuantityToBuy,
//                                     RestQtyToBuy: data?.QuantityToBuy,
//                                     Name: data.Name,
//                                     UPC: data.UPC,
//                                 });
//                         }
//                     }
//                 }
//                 else{
//                     // On cree un new cart
//                     //console.log("object ==> On cree un new cart");
//                     const refCart = cartOrderCollection.doc()

//                     for (const data of SelectedItem) {
//                         data.InCart = true;
//                         // si IsInOder == true, on est oblige de creer un new cart
//                         // si on supprime un produit dans la cart, on le remet hastobuy = true et IsInCart = false
//                         // si IsValidCart == true, on affiche ces produits sur l'application mobile


//                         batch.set(refCart, {CartRef: lastCartRef+1, CreatedBy: userInfo, IsValidCart: false, IsInOder: false, CreateAt: new Date(), VendorsId: VendorId, VendorName: VendorName })

//                         const refItem = itemsCollection.doc(data.id)
//                         batch.update(refItem, { IsInCart: true })

//                         const doc = await cartOrderCollection.doc(refCart.id).collection("cart_items").doc(data.id).set(
//                             {
//                                 Categorie: data.Categorie,
//                                 ItemId: data.id,
//                                 ImageUrl: data.ImageUrl,
//                                 InternalId: data.InternalId,
//                                 LastBuyPrice: data?.LastBuyPrice ?? 0,
//                                 QuantityInPO: data.QuantityInPO,
//                                 QuantityInShpping: data.QuantityInShpping,
//                                 SalePriceMutator: data.SalePriceMutator,
//                                 VendorIds: data.VendorIds,
//                                 hasToBuy: data.hasToBuy,
//                                 Vendors: data?.Vendors  ?? null,
//                                 QuantityToBuy: data?.QuantityToBuy,
//                                 RestQtyToBuy: data?.QuantityToBuy,
//                                 Name: data.Name,
//                                 UPC: data.UPC,
//                             });
//                     }
//                 }

//                 //console.log("befor batch");
          
//                 await batch.commit()

//             } else {
//                 //console.log("Else ComposeFilter");
//             }

//             isFunction(callback) && callback()
//         } catch (error) {
//             dispatch(hasError(error))
//         }
//     }
// }

export const getPurchasesCart = (loadMore = false, limit = 100, callback = null) => {

    return async (dispatch, getState) => {
        try {
            dispatch(startLoading())

            const { cursor, list } = selectInventory(getState());
            let queryRef = null;

            //console.log("object");
            queryRef = cartOrderCollection
                .where('IsValidCart', '==', false)

            const docSnap = loadMore
                ? await queryRef.startAfter(cursor).get()
                : await queryRef.get();

            const items = docSnap.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() }));

            //console.log("getPurchasesCart ==> "+ JSON.stringify(items));

            dispatch(gotCartForPurchase({
                list: loadMore ? [...list, ...items] : items,
                cursor: docSnap.docs[docSnap.docs.length - 1],
                hasMore: !(items.length < limit)
            }))
            isFunction(callback) && callback()
        } catch (error) {
            dispatch(hasError(error))
        }
    }
}


export const CreateAutomaticOrder = (OrderData, callback) =>{


    return async (dispatch) => {
        try {
            //console.log("in slice = "+ JSON.stringify(OrderData));
            await TestFunctionCollection.add(OrderData);

            /*var newCityRef = TestFunctionCollection.doc();

            // later...
            await newCityRef.set(OrderData);*/


            isFunction(callback) && callback()
        } catch (error) {
            dispatch(hasError(error))
        }
    }
}

export const AddQuatityForMonth = (id, newQuantity, callback = null) => {
    let value = 0;
    let quantityToBy = 0;



    return async (dispatch) => {
        try {

            const batch = firestore.batch();


            const ref = itemsCollection.doc(id)
            batch.update(ref, { QuatityForMonth: newQuantity })
            batch.update(ref,{QuantityToBuy: newQuantity*3})
            await batch.commit()

            isFunction(callback) && callback()

        } catch (error) {
            dispatch(hasError(error))
        }
    }
}

export const AddProductStatus = (id, NotImportantToPurchase, callback = null) => {
    return async (dispatch) => {
        try {
            const batch = firestore.batch();


            const ref = itemsCollection.doc(id)
            batch.update(ref, { NotImportantToPurchase: NotImportantToPurchase })

            await batch.commit()

            isFunction(callback) && callback()

        } catch (error) {
            dispatch(hasError(error))
        }
    }
}
export const UpdateProductQuantityLeft = (id, Quantity, callback = null) => {
    return async (dispatch) => {
        try {
            const batch = firestore.batch();


            const ref = itemsCollection.doc(id)
            batch.update(ref, { RestQtyToBuy: Quantity })

            await batch.commit()

            isFunction(callback) && callback()

        } catch (error) {
            dispatch(hasError(error))
        }
    }
}

export const initData = (resolveShipping = null, resolveReceiving = null) => {
    return (dispatch) => {
        try {


            dispatch(getInventory(INVENTORY_FILTER_DEFAULT))
            dispatch(getCurrentINShippingOrders(resolveShipping))
            dispatch(getCurrentINReceivingOrders(resolveReceiving))
            dispatch(getActivePurchaseOrders(resolveReceiving))

        } catch (error) {
            dispatch(hasError(error))
        }
    }
}

export const fetchItemParent = (item, loadingCallback) => {

    const setLoading = (state) => loadingCallback && loadingCallback(state)

    return async (dispatch, getSate) => {
        try {
            setLoading(true)

            const { byId = {} } = getSate()?.inventory

            let data = {}

            if (!byId[item?.id]) {
                data[item?.id] = item;

                const parentSnap = await itemsCollection.doc(item?.ParentId).get()

                if (parentSnap.exists) {
                    data[parentSnap?.id] = { id: parentSnap.id, ...parentSnap.data() };

                    if (parentSnap.data()?.IsParent) {

                        await Promise.all((parentSnap.data()?.IsParent || [])?.map(async sub => {

                            const subSnap = await itemsCollection.doc(sub?.ItemId).get()

                            if (subSnap.exists) {
                                data[subSnap?.id] = { id: subSnap.id, ...subSnap.data() };
                            }

                            return true

                        }))

                    }

                }

                dispatch(registerItems(data))
            }

            //console.log('---end')

            setLoading(false)

        } catch (e) {
            //console.log(e)
            setLoading(false)
        }
    }
}

export const getInventoryQuantity = (filters, loadMore = false, limit = 100, callback = null, filterbyDate = "") => {

    return async (dispatch, getState) => {
        try {
            dispatch(startLoading())

            const { cursor, list } = selectInventory(getState());


            let queryRef = null;
            queryRef = itemsCollection
                .orderBy('QuatityForMonth', 'asc')
                .where('QuatityForMonth', '<=', 0)
                .limit(limit);

            const docSnap = loadMore
                ? await queryRef.startAfter(cursor).get()
                : await queryRef.get();

            const items = docSnap.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() }))//.filter(e => (e?.QuatityForMonth <= 0 || !e?.QuatityForMonth) && e?.InternalId );


            dispatch(gotInventory({
                list: loadMore ? [...list, ...items] : items,
                cursor: docSnap.docs[docSnap.docs.length - 1],
                hasMore: !(items.length < limit)
            }))

            isFunction(callback) && callback()

        } catch (error) {
            dispatch(hasError(error))
        }
    }
}

// export const AddToCart = (itemId, newQuantity,lastQuantity, callback = null) => {
//     return async (dispatch) => {
//         try {
//             const batch = firestore.batch();
//             const ref = itemsCollection.doc(itemId).collection("items").doc(itemId);
//             batch.update(ref, {QuantityToBuy: newQuantity,
//                 /*, RestQtyToBuy: lastQuantity- newQuantity*/});
//             await batch.commit();

//             dispatch(updateQuantityToBuy(itemId, newQuantity));

//             isFunction(callback) && callback();
//         } catch (error) {
//             console.log(error);
//         }
//     };
// };

// export const updateQuantityToBuy = (itemId, newQuantity) => {
//     return {type: 'purchaseCartList/updateQuantityToBuy', payload: {itemId, newQuantity}};
// }


/*
export const filterProductToBuyByVendorValid = () => {
    return async (dispatch, getState, {getFirebase}) => {
        try {
            dispatch(startLoading())
            
            const {cursor, list} = selectInventory(getState());

            let queryRef = itemsCollection
                .orderBy('QuantityAvailable', 'asc')
                .where('QuantityAvailable', '>=', 0)
                .where('hasToBuy', '==', true)
                .limit(limit);

            const query = itemsCollection
                .where("IsProductValidated", "==", true)
                .limit(30)

            const snap = await query.get();
            const docs = snap.docs.map(one => ({id: one.id, ...one.data()}))

            dispatch({type: SEARCH_ITEM_SUCCESS, payload: docs})

            dispatch(setSnap({
                query,
                cursor: snap.docs[snap.docs.length - 1]
            }))

        } catch (e) {
            dispatch({type: SEARCH_ITEM_FAILIRE, error: e})
        }
    }
}
*/